import {
  GET_RESPONSE_TYPE,
  managerPerformanceConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import {
  success,
  withSpinner,
  failure,
} from "../../../../redux/actions/utilities";
import { brandPerformanceService } from "../../../shared-screens/services";

const { ALL_MANAGER_RESPONSE_DATA, CUSTOMER_RESPONSES_EXPORT_ALL_DATA } =
  managerPerformanceConstants;

const { GET_MANAGER_USER_RESPONSES } = GET_RESPONSE_TYPE;

const getAllManagerResponsesItemsForExport = (
  createDateFrom,
  createDateTo,
  managerId,
  body,
) => {
  return (dispatch) => {
    withSpinner(dispatch, ALL_MANAGER_RESPONSE_DATA, () =>
      brandPerformanceService
        .getRecordPaginationResponses({
          createDateFrom: createDateFrom,
          createDateTo: createDateTo,
          id: managerId,
          type: GET_MANAGER_USER_RESPONSES,
          ...body,
        })
        .then(
          (response) => {
            dispatch(
              success(
                response.pageData.result,
                CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
              ),
            );
          },
          (error) => {
            dispatch(resetAllExportItems());
            customToast(error, toastTypes.ERROR);
          },
        )
    );
  };
};

const resetAllExportItems = () => {
  return (dispatch) => {
    dispatch(failure([], CUSTOMER_RESPONSES_EXPORT_ALL_DATA));
  };
};

export const managerPerformanceActions = {
  getAllManagerResponsesItemsForExport,
  resetAllExportItems,
};
